module.exports = __webpack_public_path__ + "media/images/web/favicon/apple-icon-60x60-8f877cace9770b5b542aee9d05e3de4c.png";